export default __webpack_public_path__ + "static/media/logoWhite.b7aa2e53.svg";